import { useCallback, useEffect, useRef, useState } from 'react';

export function useDebouncedSave(value, saveCallback, options = {}) {
    const { delay = 2500 } = options,
        [state, setState] = useState(value),
        hasChangesRef = useRef(false),
        timeoutRef = useRef(),
        stateRef = useRef(value);

    stateRef.current = state;

    // Update state when value changes
    useEffect(() => {
        if (value !== state) {
            setState(value);
        }
    }, [value]);

    // Set timeout to save state
    useEffect(() => {
        if (hasChangesRef.current) {
            timeoutRef.current = setTimeout(() => {
                saveCallback(stateRef.current);
            }, delay);
        }
        return () => clearTimeout(timeoutRef.current);
    }, [state]);

    // When unmounting, save the value
    useEffect(() => {
        return () => {
            if (!hasChangesRef.current) return;
            saveCallback(stateRef.current);
        };
    }, []);

    // Changes handler
    const handleChange = useCallback((value) => {
        hasChangesRef.current = true;
        setState(value);
    }, []);

    return [state, handleChange];
}
